module.exports = __webpack_public_path__ + "img/898-0275c4.png";